import { useSiteSettings } from "./settings";
import { DEFAULT_CONTENT, DEFAULT_THEME } from "./defaultContent";

/** useContent(page) — returns content for a given page, merged with defaults.
 * The admin can edit every key from /admin/contenu and updates apply
 * immediately on save (cache invalidated). */
export function useContent(page) {
  const { settings } = useSiteSettings();
  const remote = (settings?.content && settings.content[page]) || {};
  const defaults = DEFAULT_CONTENT[page] || {};
  // Shallow merge is enough — remote keys win, missing keys fallback to defaults.
  // Arrays are replaced wholesale (admin-edited lists are authoritative).
  return { ...defaults, ...remote };
}

export function useTheme() {
  const { settings } = useSiteSettings();
  return { ...DEFAULT_THEME, ...(settings?.theme || {}) };
}
